import DashboardPageLayout from "../Pages/Dashboard/DashboardPageLayout";
import CareerJobPost from "../Pages/Career/postJob";
import AllJoBs from "../Pages/Career/allJobs";
import PostFinancialReport from "../Pages/Reports/postFinancialStatements";
import PostBODReport from "../Pages/Reports/postBODReport";
import AllReports from "../Pages/Reports/AllReports";
import AllApplicants from "../Pages/Applicants/allApplicants";
import PreApplicants from "../Pages/Applicants/preApplicants";
import CustomerQueries from "../Pages/Customer/customerQueries";
import ViolationReports from "../Pages/Customer/violationsReport";
import { BiSolidBriefcase } from "react-icons/bi";
import { PiFilesFill } from "react-icons/pi";
import { RiCustomerService2Line } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
const appRoutes = [
  {
    index: true,
    element: <AllJoBs />,
    state: "home",
  },
  {
    path: "/",
    element: <DashboardPageLayout />,
    state: "career",
    sidebarProps: {
      displayText: "Career",
      icon: <BiSolidBriefcase className="text-xl" />,
    },
    child: [
      {
        path: "/",
        element: <AllJoBs />,
        state: "career.allJobs",
        sidebarProps: {
          displayText: "Jobs",
        },
      },
      {
        path: "/postjob",
        element: <CareerJobPost />,
        state: "career.postjob",
        sidebarProps: {
          displayText: "Post Job",
        },
      },
    ],
  },
  {
    path: "/reports",
    element: <DashboardPageLayout />,
    state: "reports",
    sidebarProps: {
      displayText: "Reports",
      icon: <TbReportAnalytics className="text-xl" />,
    },
    child: [
      {
        path: "/reports/financialreports/postreport",
        element: <PostFinancialReport />,
        state: "reports.financialreports.postreport",
        sidebarProps: {
          displayText: "Add Financial Statement",
        },
      },
      {
        path: "/reports/boardofdirecter/postreport",
        element: <PostBODReport />,
        state: "reports.boardofdirecter.postreport",
        sidebarProps: {
          displayText: "Add Board of Director",
        },
      },
      {
        path: "/reports/allreports",
        element: <AllReports />,
        state: "reports.allreports",
        sidebarProps: {
          displayText: "All Reports",
        },
      },
    ],
  },
  {
    path: "/applicants",
    element: <DashboardPageLayout />,
    state: "applicants",
    sidebarProps: {
      displayText: "Applicants",
      icon: <PiFilesFill className="text-xl" />,
    },
    child: [
      {
        path: "/applicants/allapplicants",
        element: <AllApplicants />,
        state: "applicants.allapplicants",
        sidebarProps: {
          displayText: "Job Applicants",
        },
      },
      {
        path: "/applicants/preapplicants",
        element: <PreApplicants />,
        state: "applicants.preapplicants",
        sidebarProps: {
          displayText: "Open Applicants",
        },
      },
    ],
  },
  {
    path: "/customer",
    element: <DashboardPageLayout />,
    state: "customer",
    sidebarProps: {
      displayText: "Compliance",
      icon: <RiCustomerService2Line className="text-xl" />,
    },
    child: [
      {
        path: "/customer/queries",
        element: <CustomerQueries />,
        state: "customer.queries",
        sidebarProps: {
          displayText: "Customer Queries",
        },
      },
      {
        path: "/customer/violations",
        element: <ViolationReports />,
        state: "customer.violations",
        sidebarProps: {
          displayText: "Violation Reports",
        },
      },
    ],
  },
];
export default appRoutes;
